<template>
  <a-modal v-model:open="open" :footer="null">
    <div class="flex flex-col py-[10px]">
      <iconpark-icon class="icon" name="Popupiconwarn"></iconpark-icon>
      <div class="title justify-center mt-[12px]">
        {{ $t('qu-xiao-ding-yue') }}
      </div>
      <div class="sub justify-center text-center mt-[10px]">
        {{ $t('nin-zhen-de-yao-li-kai-wo-men-le-ma') }}
      </div>
      <div class="panel flex justify-center mt-[20px] gap-[20px]">
        <a-button class="w-[90px]" @click="handleConfirm">
          {{ $t('que-ren') }}
        </a-button>
        <a-button class="w-[90px]" type="primary" @click="open = false">
          {{ $t('qu-xiao') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
import { deleteOrderSubscription } from '~/api/module/rights.ts'
const open = defineModel('open', { default: false })
const { $t } = useNuxtApp()

const handleConfirm = async () => {
  try {
    await deleteOrderSubscription()
    message.success($t('qu-xiao-ding-yue-you-jian-yi-fa-song-qing-cha-shou'))
  } catch (err) {
    consola.error(err)
  }
  open.value = false
}
</script>

<style lang="scss" scoped>
.icon {
  font-size: 50px;
}
.title {
  font-weight: 600;
  font-size: 16px;
  color: var(--text-1);
  line-height: 22px;
  text-align: center;
}
.sub {
  font-weight: 400;
  font-size: 14px;
  color: var(--text-1);
  line-height: 20px;
}
</style>
